import { useContext } from 'react';
import AppContext from '../../../AppContext';
import ReservesRowData from './ReservesRowData';
import styles from './ReservesRow.module.css';
import { RatioFormat, DollarFormat } from '../../format';
import { DataResult } from '../../model/DataResult';
import RowHelmet from '../RowHelmet';

function rowClassSwitch(rowClass: string = '') {
  switch (rowClass) {
    case 'TOTAL':
      return styles.total;
    case 'GRAND_TOTAL':
      return styles.grand_total;
    default:
      return '';
  }
}

function hasAnyOutsideBenchmarks(
  percentOrPointChange: DataResult,
  dollarChange: DataResult,
  currentYearValue: DataResult,
  priorYearValue: DataResult,
  oneYearDevelopment: DataResult,
  priorYearPHS: DataResult,
  twoYearDevelopment: DataResult,
  priorYearTwoPHS: DataResult
) {
  return (
    percentOrPointChange?.outsideBenchmark ||
    dollarChange?.outsideBenchmark ||
    currentYearValue?.outsideBenchmark ||
    priorYearValue?.outsideBenchmark ||
    oneYearDevelopment?.outsideBenchmark ||
    priorYearPHS?.outsideBenchmark ||
    twoYearDevelopment?.outsideBenchmark ||
    priorYearTwoPHS?.outsideBenchmark
  );
}

export default function ReservesRow({
  rowKey,
  rowClass,
  label,
  benchmark,
  percentOrPointChange,
  dollarChange,
  currentYearValue,
  priorYearValue,
  oneYearDevelopment,
  priorYearPHS,
  twoYearDevelopment,
  priorYearTwoPHS,
  sectionKey
}: ReservesRowData) {
  const { showBenchmark } = useContext(AppContext);

  return (
    <div
      id={sectionKey ? sectionKey + '-' + rowKey : 'rowKey-' + rowKey}
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse} ${rowClassSwitch(
        rowClass
      )}`}>
      <RowHelmet
        label={label}
        isOutsideBenchmark={hasAnyOutsideBenchmarks(
          percentOrPointChange,
          dollarChange,
          currentYearValue,
          priorYearValue,
          oneYearDevelopment,
          priorYearPHS,
          twoYearDevelopment,
          priorYearTwoPHS
        )}
        benchmarkText={benchmark}
      />
      <RatioFormat {...percentOrPointChange} showDefaultValue={true} />
      <DollarFormat {...dollarChange} showDefaultValue={true} />
      <p></p>
      <p></p>
      <DollarFormat {...currentYearValue} />
      <DollarFormat {...priorYearValue} />
      <DollarFormat {...oneYearDevelopment} />
      <RatioFormat {...priorYearPHS} />
      <DollarFormat {...twoYearDevelopment} />
      <RatioFormat {...priorYearTwoPHS} />
    </div>
  );
}
